import { h, Component } from 'preact';
import './index.less';
import I18n from '../../lib/I18n';
import EventBus from '../../lib/EventBus';
import { getReviewRoute } from '../../lib/RoutePath';

class OrderAlreadyConfirmed extends Component {
  constructor () {
    super();
    this.state = {
      orderAlreadyConfirmedError: false,
      onDismiss: null,
      containerClass: ''
    };
  }

  componentDidMount () {
    EventBus.addListener(EventBus.TYPE.ORDER_CONFIRMED_ERROR, this.handleOrderConfirmError);
  }

  componentWillUnmount () {
    EventBus.removeListener(EventBus.TYPE.ORDER_CONFIRMED_ERROR, this.handleOrderConfirmError);
  }

  handleOrderConfirmError = ({
    orderAlreadyConfirmedError,
    onDismiss = null,
    containerClass = ''
  }) => {
    if (!orderAlreadyConfirmedError) {
      onDismiss = null;
      containerClass = '';
    }
    this.setState({ orderAlreadyConfirmedError, containerClass, onDismiss });
  };

  onDismissClick = () => {
    const { onDismiss } = this.state;
    EventBus.notify(EventBus.TYPE.ORDER_CONFIRMED_ERROR, {
      orderAlreadyConfirmedError: false
    });
    if (typeof onDismiss === 'function') {
      onDismiss();
    }

    window.location.replace(getReviewRoute());
  };

  render () {
    const { orderAlreadyConfirmedError, containerClass } = this.state;

    if (!orderAlreadyConfirmedError) {
      return null;
    }

    return (
      <div className={`review-order-already-confirmed-error-overlay ${containerClass}`}>
        <div className="order-already-confirmed-error">
          <div className="title">{I18n.t('CANNOT_PLACE_ORDER')}</div>
          <div className="subtitle">{I18n.t('ORDER_ALREADY_CONFIRMED')}</div>

          <div className="actions">
            <div className="action dismiss" onClick={this.onDismissClick}>
              {I18n.t('DISMISS')}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OrderAlreadyConfirmed;
